import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const PenTablet = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <path d="M2.437 11.307a.902.902 0 1 1 .002-1.804.902.902 0 0 1-.002 1.804z" />
      <path d="M12.413 5.443c0-.151.123-.274.274-.274h1.778c.65 0 1.176.527 1.176 1.176v8.119c0 .65-.526 1.176-1.176 1.176H1.535c-.65 0-1.176-.526-1.176-1.176V6.345c0-.65.527-1.176 1.176-1.176h8.487a.274.274 0 0 1 0 .548H1.535a.628.628 0 0 0-.628.628v8.119c0 .347.281.628.628.628h12.93a.628.628 0 0 0 .628-.628V6.345a.628.628 0 0 0-.628-.628h-1.778a.274.274 0 0 1-.274-.274z" />
      <path d="M2.437 6.922a.328.328 0 0 0-.328.328v.601a.328.328 0 0 0 .656 0V7.25a.328.328 0 0 0-.328-.328zm-.875.327a.875.875 0 0 1 1.75 0v.601a.875.875 0 0 1-1.75 0v-.601zm2.405-.601c0-.151.123-.274.274-.274h4.847a.274.274 0 0 1 0 .548H4.515v6.97h9.376v-6.97h-2.138a.274.274 0 0 1 0-.548h2.412c.151 0 .274.123.274.274v7.518a.274.274 0 0 1-.274.274H4.242a.274.274 0 0 1-.274-.274V6.648zm-1.53 5.987a.328.328 0 0 0-.328.328v.601a.328.328 0 0 0 .656 0v-.601a.328.328 0 0 0-.328-.328zm-.875.328a.875.875 0 0 1 1.75 0v.601a.875.875 0 0 1-1.75 0v-.601z" />
      <path d="M14.254.976a.328.328 0 0 0-.46.058L8.66 7.644l-.617 2.055 1.848-1.101 5.133-6.608a.328.328 0 0 0-.058-.46l-.712-.553zm-4.049 8.072-2.414 1.438a.276.276 0 0 1-.148.043h-.695a.328.328 0 0 0 0 .656h2.406a.875.875 0 0 1 0 1.75H7.249a.274.274 0 0 1 0-.548h2.105a.328.328 0 0 0 0-.656H6.948a.875.875 0 0 1 0-1.75h.439l.764-2.546a.282.282 0 0 1 .053-.098l5.157-6.64a.875.875 0 0 1 1.228-.154l.712.553a.875.875 0 0 1 .154 1.228L10.29 8.973a.28.28 0 0 1-.088.074z" />
    </svg>
  );
};

PenTablet.category = 'product-category';

PenTablet.displayName = 'PenTablet';
